module.exports = __webpack_public_path__ + "img/el-fondo-de-la-botella.ecf6e719.jpg";